import Vue from 'vue';
import Component from 'vue-class-component';

import { namespace } from 'vuex-class';

const AppModule = namespace('App');

@Component
export default class StepControllerMixin extends Vue {
  @AppModule.Mutation('setStep')
  protected setStep!: Function;
}
